import { render, staticRenderFns } from "./teamRegistration.vue?vue&type=template&id=7bb6d247&scoped=true&"
import script from "./teamRegistration.vue?vue&type=script&lang=js&"
export * from "./teamRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb6d247",
  null
  
)

export default component.exports